import axios from "axios";

/**
 *
 * @param query
 * @returns {Promise<any>}
 */
export const getAdmirers = (query = null) => {
    return axios.get(`admirers${ query ? ('?' + new URLSearchParams(query).toString()) : ''}`)
}